import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import { Lavandula } from './products/Lavandula';
import { YlangYlang } from './products/YlangYlang';
import { EucalyptusGlobulus } from './products/EucalyptusGlobulus';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { CymbopogonCitratus } from './products/CymbopogonCitratus';
import { Lavandula7 } from './products/Lavandula7';
import { RoseAbsolute } from './products/RoseAbsolute';
import { Lavandula6 } from './products/Lavandula6';
import { Lavandula8 } from './products/Lavandula8';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDGZsDUt11ifWiTHQp1x2f5GZXCzwEED0k",
  authDomain: "damascena.firebaseapp.com",
  projectId: "damascena",
  storageBucket: "damascena.appspot.com",
  messagingSenderId: "1001906132869",
  appId: "1:1001906132869:web:ea378dcf600333648656ec",
  measurementId: "G-N1P6R2VVJJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

const ingredient = [
  Lavandula,
  YlangYlang,
  EucalyptusGlobulus,
  CymbopogonCitratus,
  RoseAbsolute,
  Lavandula6,
  Lavandula7,
  Lavandula8,
]

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/ingredient">
          {ingredient.map((Item, index) => <Route key={index} path={`${'0000000' + (index + 1)}`.slice(-5)} element={<Item />} />)}
        </Route>
        <Route
          path="*"
          element={
            <main style={{ padding: "1rem" }}>
              <p>There's nothing here!</p>
            </main>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
